import React from 'react';
import { Button, Avatar} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import {colorIcon, styleSecondaryButton} from "../App/theme.js";
import {isMobile, parseKBSubdomain} from "../App/utils.js";
import {useNavigate} from "react-router-dom";
import {KB_TABS} from "../App/constants";

export const BackButton = ({path, backToApp, backToItems, backToChat, setActiveTab}) => {
    const navigate = useNavigate();

    const handleBack = (e) => {
        const {kbIdAsSubdomain, appsPrefix, mainDomain, protocol} = parseKBSubdomain() || {};
        if (backToApp) {
            navigate(-1)
        } else if (backToItems) {
            navigate('/?tab=' + KB_TABS.items)
        } else if (backToChat) {
            navigate('/?tab=' + KB_TABS.chat)
        } else if (kbIdAsSubdomain) {
            window.location.href = `${protocol}//${mainDomain}/dashboard`
        } else {
            navigate(path ? path : -1)
        }
    }
    return (
        <>
            {!isMobile && <Button
                color="primary"
                size={"small"}
                style={{
                  marginLeft: -20,
                  height: !isMobile && 28,
                  ...styleSecondaryButton,
                  position: "absolute",
                  top: 90,
                  zIndex: 10
                }}
              startIcon={<ArrowBack style={ styleSecondaryButton } />}
              onClick={handleBack}
                    >Back</Button>}

            {isMobile && <Avatar
                variant="outlined"
                style={{
                    position: "fixed",
                    top: 70,
                    left: 16,
                    zIndex: 10,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    color: colorIcon
                }}
                onClick={handleBack}
            >
                <ArrowBack />
            </Avatar>}
        </>
    );
};

